module.exports = __webpack_public_path__ + "assets/img/18_1859_big.64f9df2d.jpg";